import { CollectionInterface } from "../../../common/interfaces/collections/CollectionInterface";
import { CollectionProducts } from "./CollectionProducts";
import { JSX, useState } from "react";
import { setDeleteCollectionModal } from "../../../modals/deleteCollectionModal/DeleteCollectionModalSlice";
import { useAppDispatch } from "../../../app/hooks";
import { setEditCollectionModal } from "../../../modals/editCollectionModal/EditCollectionModalSlice";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

interface Props {
    collection: CollectionInterface;
}

export const CollectionItem = (props: Props): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { t } = useStringTranslation();

    const { collection } = props;

    const [active, setActive] = useState(false);

    if (collection) {
        return (
            <div className={"c-collection " + (active ? "is-active" : "")}>
                <div className="c-collection__header">
                    <div
                        className="c-collection__name"
                        onClick={() => setActive(!active)}
                    >
                        <div className="c-collection__name__icon">
                            {collection.name.charAt(0)}
                        </div>
                        <span>{collection.name}</span>
                    </div>

                    <div
                        className="c-collection__categories"
                        onClick={() => setActive(!active)}
                    >
                        <div className="c-collection__category">
                            <span>
                                {collection.machineryCount + " machinery"}
                            </span>
                        </div>
                        <div className="c-collection__category">
                            <span>
                                {collection.accessoriesCount + " accessories"}
                            </span>
                        </div>
                    </div>

                    <div className="c-collection__buttons">
                        <div className="c-collection__buttons__edit">
                            <button
                                className="c-collection__button c-collection__button--edit"
                                onClick={() => {
                                    dispatch(
                                        setEditCollectionModal({
                                            showPopup: true,
                                            collectionId: collection.id,
                                        }),
                                    );
                                }}
                            >
                                <img src="/images/pencil.svg" alt="delete" />
                                <span>{t("edit-name").toLowerCase()}</span>
                            </button>
                            <button
                                className="c-collection__button c-collection__button--delete"
                                onClick={() => {
                                    dispatch(
                                        setDeleteCollectionModal({
                                            showPopup: true,
                                            collectionId: collection.id,
                                        }),
                                    );
                                }}
                            >
                                <img src="/images/cross.svg" alt="delete" />
                                <span>{t("delete").toLowerCase()}</span>
                            </button>
                        </div>
                        <div
                            className="c-collection__button c-collection__button--expand"
                            onClick={() => setActive(!active)}
                        >
                            <div>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="c-collection__content">
                    {collection.machinery.length > 0 && (
                        <CollectionProducts
                            category={t("machinery").toLowerCase()}
                            collection={collection}
                            productCount={collection.machineryCount}
                            productPages={collection.machinery}
                        />
                    )}

                    {collection.accessories.length > 0 && (
                        <CollectionProducts
                            category={t("accessories").toLowerCase()}
                            collection={collection}
                            productCount={collection.accessoriesCount}
                            productPages={collection.accessories}
                        />
                    )}

                    {collection.spareParts.length > 0 && (
                        <CollectionProducts
                            category={t("spare-parts").toLowerCase()}
                            collection={collection}
                            productCount={collection.sparePartsCount}
                            productPages={collection.spareParts}
                        />
                    )}

                    {/*<div className="c-collection__content__export">*/}
                    {/*    <ExportBar collection={collection} exportTypes={exportTypes}/>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
    return null;
};
